<template>
<label
  class="base-image-input"
  :class="{'base-image-input_loaded': isFileLoaded, 'base-image-input_error': error }"
>
  <img
    class="base-image-input__icon"
    :class="{ 'base-image-input__icon_hidden': isFileLoaded }"
    src="../assets/download_icon.svg"
  >
  <img
    class="base-image-input__icon"
    :class="{ 'base-image-input__icon_hidden': !isFileLoaded }"
    src="../assets/check_icon.svg"
  >
  <p
    class="base-image-input__deskr"
    :class="{ 'base-image-input__deskr_hidden': error | isFileLoaded }"
  >
    {{ deskr }}
  </p>
  <p
    class="base-image-input__error"
    :class="{ 'base-image-input__error_hidden': !error }"
  >
    Фото не загружено / превышает 5mb Попробуйте еще раз
  </p>
  <input class="base-image-input__input" type="file" accept="image/*" @change="handleFileLoad">
</label>
</template>

<script>
export default {
  name: 'BaseImageInput',
  props: {
    value: {
      required: true
    },
    error: {
      required: false,
      type: Boolean,
      default: false
    },
    deskr: {
      required: false,
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isFileLoaded: false
    }
  },
  methods: {
    handleFileLoad(e) {
      if (e.target.files[0]) {
        this.$emit('input', e.target.files[0])
        this.isFileLoaded = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@use "../styles/colors";

.base-image-input {
  width: 100%;
  padding-top: 120%;
  position: relative;
  border: 1px solid colors.$grayef;
  background-color: colors.$grayef;
  color: colors.$gray8b;
  cursor: pointer;
  &_loaded {
    background-color: #fff;
    border: 1px solid #000;
  }
  &_error {
    background-color: #fff;
    border: 1px solid colors.$redff;
  }
  &__icon {
    position: absolute;
    top: calc(50% - 12px);
    left: calc(50% - 12px);
    width: 24px;
    &_hidden {
      display: none;
    }
  }
  &__input {
    display: none;
  }
  &__deskr, &__error {
    width: 70%;
    position: absolute;
    top: 60%;
    left: 17.5%;
    font-size: 10px;
    text-align: center;
    color: colors.$gray8b;
    &_hidden {
      display: none;
    }
  }
}

@media screen and (max-width: 1024px) and (orientation: portrait) {
  .base-image-input {
    &__icon {
      top: calc(50% - 15px);
      left: calc(50% - 15px);
      width: 30px;
    }
    &__deskr, &__error {
      font-size: 12px;
      line-height: 14px;
    }
  }
}
@media screen and (max-width: 767px) {
  .base-image-input {
    &__icon {
      top: calc(50% - 10px);
      left: calc(50% - 10px);
      width: 20px;
    }
    &__deskr, &__error {
      font-size: 10px;
      line-height: normal;
    }
  }
}
</style>